module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/B36ACm/tc-custom/9781913682927.jpg?1723836044114",
      "alt": "This image is the cover for the book Die Cold, The Jake Boulder Thrillers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Die Cold, The Jake Boulder Thrillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("During a terrorist attack at a Vermont ski lodge, a bartender may be the only hope for the hostages: “A new tough guy to root for.” —Matt Hilton, bestselling author of the Joe Hunter novels")]), _c('br'), _c('br'), _vm._v(" Scottish transplant Jake Boulder is tending bar at an exclusive Vermont ski resort on New Year’s Eve when armed terrorists hold up the lodge and take all the customers and guests hostage. Trapped with the others, Boulder watches in horror as the female terrorist leader disfigures a singer to make her point. He wants to fight back—but he’s unarmed and being held at gunpoint."), _c('br'), _c('br'), _vm._v(" But finally, Boulder finds a way to escape from the terrorists and searches for a way to raise the alarm. And after he discovers the terrorists’ plan to leave no witnesses to their crime, he knows he has a race against time to save as many innocent people as he can . . .")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Graham Smith\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0